
export const MyFunctions = {
    getLanguage(){
        if(localStorage.lang){
            return localStorage.lang;
        } else {
            localStorage.setItem('lang', 'EN');
                return 'EN';     
    }
}
}
